var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-list",
        [
          _vm.checkPermission("ALL_ACCESS")
            ? _c(
                "v-tooltip",
                { attrs: { right: "" } },
                [
                  _c(
                    "v-list-tile",
                    {
                      class: {
                        "list__tile--active-router":
                          "/trafic" == _vm.$route.matched[1].path
                      },
                      attrs: {
                        slot: "activator",
                        to: _vm.pathTrafic,
                        ripple: ""
                      },
                      slot: "activator"
                    },
                    [
                      _c(
                        "v-list-tile-action",
                        [
                          _c(
                            "v-badge",
                            {
                              attrs: { right: "", color: "accent" },
                              model: {
                                value:
                                  _vm.$store.state._StoreWatcheeBox
                                    .listeAllVisiteurs.length,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.$store.state._StoreWatcheeBox
                                      .listeAllVisiteurs,
                                    "length",
                                    $$v
                                  )
                                },
                                expression:
                                  "$store.state._StoreWatcheeBox.listeAllVisiteurs.length"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "caption",
                                  attrs: { slot: "badge" },
                                  slot: "badge"
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.nbVisitors) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-icon",
                                {
                                  class: {
                                    "primary--text":
                                      "/trafic" == _vm.$route.matched[1].path
                                  }
                                },
                                [_vm._v("explore")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("cap")(_vm.$t("trafic"))) +
                        " " +
                        _vm._s(
                          "(" +
                            _vm.$tc(
                              "visitors",
                              _vm.$store.state._StoreWatcheeBox
                                .listeAllVisiteurs.length,
                              { count: _vm.nbVisitors }
                            ) +
                            ")"
                        ) +
                        "\n      "
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.checkPermission("NO_PEONS")
            ? _c(
                "v-tooltip",
                { attrs: { right: "" } },
                [
                  _c(
                    "v-list-tile",
                    {
                      class: {
                        "list__tile--active-router":
                          "/stats" == _vm.$route.matched[1].path
                      },
                      attrs: {
                        slot: "activator",
                        to: { path: "/stats/audience" },
                        ripple: ""
                      },
                      slot: "activator"
                    },
                    [
                      _c(
                        "v-list-tile-action",
                        [
                          _c(
                            "v-icon",
                            {
                              class: {
                                "primary--text":
                                  "/stats" == _vm.$route.matched[1].path
                              }
                            },
                            [_vm._v("assessment")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm._f("cap")(_vm.$t("stats"))))])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.checkPermission("NO_PEONS_NOR_AGENTS")
            ? _c(
                "v-tooltip",
                { attrs: { right: "" } },
                [
                  _c(
                    "v-list-tile",
                    {
                      class: {
                        "list__tile--active-router":
                          "/management" == _vm.$route.matched[1].path
                      },
                      attrs: {
                        slot: "activator",
                        to: { path: "/management/agents" },
                        ripple: ""
                      },
                      slot: "activator"
                    },
                    [
                      _c(
                        "v-list-tile-action",
                        [
                          _c(
                            "v-icon",
                            {
                              class: {
                                "primary--text":
                                  "/management" == _vm.$route.matched[1].path
                              }
                            },
                            [_vm._v("assignment_ind")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("cap")(_vm.$t("management"))))
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.checkPermission("NO_PEONS_NOR_AGENTS")
            ? _c(
                "v-tooltip",
                { attrs: { right: "" } },
                [
                  _c(
                    "v-list-tile",
                    {
                      class: {
                        "list__tile--active-router":
                          "/media" == _vm.$route.matched[1].path
                      },
                      attrs: {
                        slot: "activator",
                        to: _vm.pathMedia,
                        ripple: ""
                      },
                      slot: "activator"
                    },
                    [
                      _c(
                        "v-list-tile-action",
                        [
                          _c(
                            "v-icon",
                            {
                              class: {
                                "primary--text":
                                  "/media" == _vm.$route.matched[1].path
                              }
                            },
                            [_vm._v("perm_media")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm._f("cap")(_vm.$t("media"))))])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.checkPermission("NO_PEONS_NOR_AGENTS")
            ? _c(
                "v-tooltip",
                { attrs: { right: "" } },
                [
                  _c(
                    "v-list-tile",
                    {
                      class: {
                        "list__tile--active-router":
                          "/botbuilder" == _vm.$route.matched[1].path
                      },
                      attrs: {
                        slot: "activator",
                        to:
                          this.$store.state._User.bots.length !== 0 &&
                          this.$store.state._User.bots[0].USR_ID !== 0
                            ? { path: "/botbuilder/openAIConfig" }
                            : { path: "/botbuilder/openAIConfig" },
                        ripple: ""
                      },
                      slot: "activator"
                    },
                    [
                      _c(
                        "v-list-tile-action",
                        [
                          _c(
                            "v-icon",
                            {
                              class: {
                                "primary--text":
                                  "/botbuilder" == _vm.$route.matched[1].path
                              }
                            },
                            [_vm._v("psychology")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v("Bot Builder")])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.checkPermission("NO_PEONS")
            ? _c(
                "v-tooltip",
                { attrs: { right: "" } },
                [
                  _c(
                    "v-list-tile",
                    {
                      class: {
                        "list__tile--active-router":
                          "/settings" == _vm.$route.matched[1].path
                      },
                      attrs: {
                        slot: "activator",
                        to: { path: "/settings/preview" },
                        ripple: ""
                      },
                      slot: "activator"
                    },
                    [
                      _c(
                        "v-list-tile-action",
                        [
                          _c(
                            "v-icon",
                            {
                              class: {
                                "primary--text":
                                  "/settings" == _vm.$route.matched[1].path
                              }
                            },
                            [_vm._v("settings")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("cap")(_vm.$t("settings"))))
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18ad8d93", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18ad8d93","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzMenu.vue
// module id = null
// module chunks = 